import { createSlotRecipe } from './runtime';

const drawerConfig = {"name":"drawer","slots":["backdrop","panel","head","titles","overline","title","close","body"],"defaultVariants":{"inline":false},"variantMap":{"inline":["false","true"]}}

export const drawer = /* @__PURE__ */ createSlotRecipe(drawerConfig)